import { GranolaIcon } from "#components/ui/GranolaIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const granolaManifest: IntegrationManifest = {
    key: "granola",
    displayName: "Granola",
    nameKey: "channels.granola",
    descriptionKey: "granolaDescription",
    trayDescriptionKey: "composerTrayDescriptions.granola",
    cardDescriptionKey: "connectIntegration.descriptions.granola",
    connectedContentKeys: ["granolaNotes"],
    brandColor: "#B2C248",
    brandForegroundColor: "core_abyss",
    iconUrl: IconAssets.Granola,
    iconUrlAlt: IconAssets.GranolaAlt,
    iconUrlAltDark: IconAssets.GranolaAltDark,
    glyph: GranolaIcon,
    channelType: "UserGranolaMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
